import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0085',
    ecrans: [
        '00-2'
    ]
});

